import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { share } from 'rxjs/operators';
import { SecureStorageService } from './secure-storage.service';

@Injectable({
    providedIn: 'root'
})
export class StorageManagement {
    private onSubject = new Subject<{ key: string, value: any }>();
    public changes = this.onSubject.asObservable().pipe(share());
    private subjectMap = {}
    private changesMap = {}
    public changesForKey(key) {
        if (this.subjectMap[key])
            return this.subjectMap[key]
        else {
            throw new Error("Changes Subscribed before Observable setup on Storage Management");
        }
    }

    constructor(private secureStorageService: SecureStorageService) { }

    public getStorage() {
        let s = [];
        for (let i = 0; i < localStorage.length; i++) {
            s.push({
                key: localStorage.key(i),
                value: this.secureStorageService.get(localStorage.key(i))
            });
        }
        return s;
    }

    public store(key: string, data: any): void {
        this.secureStorageService.set(key, JSON.stringify(data));
        if (this.subjectMap[key])
            this.subjectMap[key].next({ key: key, value: data })
        this.onSubject.next({ key: key, value: data })
    }

    public get(key: string): any {
        return { key: key, value: this.secureStorageService.get(key) }
    }

    public clear(key) {
        this.secureStorageService.remove(key);
        if (this.subjectMap[key])
            this.subjectMap[key].next({ key: key, value: null })
        this.onSubject.next({ key: key, value: null });
    }


    public start(): void {
        window.addEventListener("storage", this.storageEventListener.bind(this));
    }

    public startForAKey(key): void {
        this.subjectMap[key] = new Subject<{ key: string, value: any }>();
        this.changesMap[key] = this.subjectMap[key].asObservable().pipe(share());
        this['key'] = key
        window.addEventListener("storage", this.storageEventListenerOnKey.bind(this));
    }

    private storageEventListener(event: StorageEvent) {
        if (event.storageArea == localStorage) {
            let v;
            try { v = JSON.parse(event.newValue); }
            catch (e) { v = event.newValue; }
            this.onSubject.next({ key: event.key, value: v });
        }
    }

    private storageEventListenerOnKey(event: StorageEvent) {
        if (event.storageArea == localStorage) {
            let key = event.key
            if (key && this.subjectMap[key]) {
                let v;
                try { v = this.secureStorageService.get(key); }
                catch (e) { v = event.newValue; }
                this.subjectMap[key].next({ key: key, value: v });
            }
        }
    }

    public stop(): void {
        window.removeEventListener("storage", this.storageEventListener.bind(this));
        this.onSubject.complete();
    }

    public stopForAKey(key): void {
        window.removeEventListener("storage", this.storageEventListenerOnKey.bind(this, key));
        this.subjectMap[key].complete();
    }
}
